import { createContext } from 'react';
/**
 * Context to store choices and functions to retrieve them.
 *
 * Use the useChoicesContext() hook to read the context.
 */
export var ChoicesContext = createContext(undefined);
//# sourceMappingURL=ChoicesContext.js.map